import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=492d9d0a&scoped=true&"
import script from "./ModalCreate.vue?vue&type=script&lang=js&"
export * from "./ModalCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreate.vue?vue&type=style&index=0&id=492d9d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d9d0a",
  null
  
)

component.options.__file = "ModalCreate.vue"
export default component.exports